import { Injectable } from '@angular/core';
import { catchError, delay, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ExcursionServiceService {
  //apiUrl: string = 'http://127.0.0.1:8000/new_excursion/excursion/api/';
  apiUrl: string = environment.apiUrl;
  token: any = localStorage.getItem('token') == null ? '' : localStorage.getItem('token')
  
  // request_flag=false;
  getheader() {
    this.token = localStorage.getItem('token') == null ? '' : localStorage.getItem('token')
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': this.token

      })
    };
  }

  getheaderoption() {
    this.token = localStorage.getItem('token') == null ? '' : localStorage.getItem('token')
    return {
      headers: new HttpHeaders({
        'token': this.token
      })
    }

  }

  log_httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',

    })
  };
  // headers = new HttpHeaders().set('Content-Type', 'application/json');
  // headers.set('Content-Type', 'application/json');



  constructor(private httpClient: HttpClient) { }
  list(): Observable<any> {
    // this.getheader().headers.set('token','')
    return this.httpClient.get(this.apiUrl + 'dashboard/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  prioritylist(): Observable<any> {
    ////console.log(this.getheader())
    return this.httpClient.get(this.apiUrl + 'prioritylist/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  Classificationlist(): Observable<any> {
    return this.httpClient.get(this.apiUrl + 'classification/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  businessunitlist(): Observable<any> {
    return this.httpClient.get(this.apiUrl + 'businessunit/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  userlist(): Observable<any> {
    return this.httpClient.get(this.apiUrl + 'userlist', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  excursionTypeslist(): Observable<any> {
    return this.httpClient.get(this.apiUrl + 'excursion_types/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  update_service_remarks(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'remarks_excursion_update/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  update_supplier_remarks(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'supplier_remarks_update/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  update_multiple_excursion(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'excursion_multiple_update/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  update_service_location(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'update_location/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  smtp_mail_send(data: any): Observable<any> {
    return this.httpClient.post(this.apiUrl + 'smtp_mail_send/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getdashboard_list(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'dashboard/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getsupplier_list(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'supplier_list/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  setsupplier(data: any): Observable<any> {
    console.log(typeof (data))
    console.log(data)
    return this.httpClient.patch(this.apiUrl + 'assigin_service_provider/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  multi_setsupplier(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'assigin_service_provider_mult/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  update_Excursion(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'excursion_update/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  multi_update_Excursion(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'excursion_update_mult/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  supplier_remarks_mult(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'supplier_remarks_mult_update/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getexcursion_list(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'excursion_list/', data, this.getheader()).pipe(

      catchError(this.handleError)
    );
  }
  getexcursion_Details(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'excursion_details/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getexcursionHistory_Details(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'get_history_details/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  search_loaction(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'get_hotel_search/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  search_loaction_hotel(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'get_hotel_locationsearch/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getexcursionLocation_Details(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'get_location_details/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getexcursionCost_Details(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'get_cost_details/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getdaily_Report(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'daily_report/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  dashboarsetting(data: any): Observable<any> {
    return this.httpClient.post(this.apiUrl + 'dashboard_settings/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  updatedashboarsetting(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'dashboard_settings/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  updatefile_confirmation(data: FormData): Observable<any> {
    ////console.log(data)
    return this.httpClient.post(this.apiUrl + 'confirmation_file_upload/', data, this.getheaderoption()).pipe(
      catchError(this.handleError)
    );
  }
  updateexcursionrearks(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'remarks_excursion_update/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  get_mail_data(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'load_mail_data/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  forgotPsw(data: any): Observable<any> {
    return this.httpClient.post(this.apiUrl + 'forgotpsw/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }
  getdashboarsetting(): Observable<any> {
    return this.httpClient.get(this.apiUrl + 'dashboard_settings/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  GetSupplierCost(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'GetSupplierCost/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  compareDates = (a: any, b: any): number => {

    //  let c=new Date(a).toISOString().replace(/T.*/,'').split('-').reverse().join('-')
    //  let d=new Date(b).toISOString().replace(/T.*/,'').split('-').reverse().join('-')
    //  //console.log(c)
    //  //console.log(d)
    //  if(c==d){
    //   return +1;
    //  }
    console.log(a)
    console.log(b)
    if (a < b) return -1;
    if (a >= b) return +1;


    return 0; // dates are equal
  };
  login_validate(data: any): Observable<any> {
    console.log(this.apiUrl);
    return this.httpClient.post(this.apiUrl + 'login_validate/', data, this.log_httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  internal_login_validate(data: any): Observable<any> {
    return this.httpClient.post(this.apiUrl + 'internal_login_validate/', data, this.log_httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  log_write(data: any): Observable<any> {
    return this.httpClient.post(this.apiUrl + 'log_write/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getTransferList(data: any): Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/bookings/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getTransferListSingle(data: any):Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/bookingdetails/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getMasterList():Observable<any>{
    return this.httpClient.get(this.apiUrl + 'transfer/MasterList/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  update_supplier_driver_transfer(data: any): Observable<any> {
    return this.httpClient.patch(this.apiUrl + 'transfer/UpdateSupplierDriver/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getPriorTime():Observable<any>{
    return this.httpClient.get(this.apiUrl + 'transfer/PriorTime/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  updatePriorTime(data: any): Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/PriorTime/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getSendEmailToSupplier(data: any):Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/getSendEmailForSupplier/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getDriverDutySheet(data: any):Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/getDriverDutySheet/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  SendEmailToSupplier(data: any):Observable<any>{
    return this.httpClient.post(this.apiUrl + 'transfer/SendEmailToSupplier/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getExcTransferData(data: any):Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/getExcTransferData/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  updateSupplierConfirmation(data: any):Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/updateSupplierConfirmation/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  getArrivalDepartureReport(data: any): Observable<any>{
    return this.httpClient.patch(this.apiUrl + 'transfer/getArrivalDepartureReport/', data, this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  export_ArrivalDepartureReport(data: any): Observable<any>{
    this.token = localStorage.getItem('token') == null ? '' : localStorage.getItem('token')
    return this.httpClient.patch(this.apiUrl + 'transfer/exportArrivalDepartureReport/', data, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': this.token
      })
    }).pipe(
      //map((response: any) => this.extractBlob(response)),
      catchError(this.handleError)
    );
  }

  export_DriverDutySheetReport(data: any): Observable<any>{
    this.token = localStorage.getItem('token') == null ? '' : localStorage.getItem('token')
    return this.httpClient.patch(this.apiUrl + 'transfer/exportDriverDutySheetReport/', data, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': this.token
      })
    }).pipe(
      //map((response: any) => this.extractBlob(response)),
      catchError(this.handleError)
    );
  }

  private extractBlob(response: HttpResponse<any>): Blob {
    // Extract blob from HttpResponse
    return new Blob([response.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  getarrdepreportmaster():Observable<any>{
    return this.httpClient.get(this.apiUrl + 'transfer/getarrdepreportmaster/', this.getheader()).pipe(
      catchError(this.handleError)
    );
  }

  export_ExcursionReport(data: any): Observable<any>{
    this.token = localStorage.getItem('token') == null ? '' : localStorage.getItem('token')
    return this.httpClient.patch(this.apiUrl + 'exportExcursionReport/', data, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': this.token
      })
    }).pipe(
      //map((response: any) => this.extractBlob(response)),
      catchError(this.handleError)
    );
  }

  item = {
    //     'requestid':'',
    // "serviceid":'',
    // "is_multicost":0,
    // "is_supplier":0,
    "list_item": []
  };
  getitem() {
    return this.item
  }
  setitem(data: any) {
    // this.item.requestid=data['requestid']
    // this.item.serviceid=data['service_id']
    // this.item.is_multicost=data['is_multicost']
    console.log(data)
    this.item.list_item = data
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    }
    ////console.log(error)
    // } else {
    //   console.error(
    //     `Backend returned code ${error.status}, ` +
    //     `body was: ${error.error}`);
    // }
    return throwError(
      'Something bad happened; please try again later.');
  };
}
